/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendEmail.defs.js'
export * as $defs from './sendEmail.defs.js'
